/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { d as dayjs } from '../../../_chunks/dep-0927ceb7.mjs';
import '../../../_chunks/dep-8a0ff305.mjs';
import '../../../_chunks/dep-34428f12.mjs';

function validateInputValue(value, format) {
  return dayjs(value, format).format(format) === value;
}
function formatInputValue(value, format) {
  return dayjs(value, format).format(format);
}
function closestLookup(availableArr, calcVal, step) {
  if (step <= 1) return calcVal;
  return availableArr.sort(function (a, b) {
    return Math.abs(calcVal + 1 - a) - Math.abs(calcVal + 1 - b);
  })[0];
}

export { closestLookup, formatInputValue, validateInputValue };
//# sourceMappingURL=utils.mjs.map
